// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {filter, get, map} from 'lodash';

// Components
import MassActionConfirm from '../search-data/mass-action-confirm';
import MassActionResponse from '../search-data/mass-action-response';
import BulkMappingButtons from './bulk-mapping-buttons';
import RecordDetails from '../core/record-details';
import BulkMappingTable from './bulk-mapping-table';

// Styles
import './bulk-mapping.scss';

function FranchiseHeader({ fetched, mappingData, mediaItemData }) {
  const renderMappingResponseRecord = () => {
    const { echostarId, ...rest } = get(mappingData, 'franchise') || {};
    const echostarIdField = isRecordShow() ? 'franchiseEchostarId' : 'echostarId';
    const recordData = {
      [echostarIdField]: echostarId || 'pending',
      ...rest,
    };

    return <RecordDetails {...getRecordDetailsProps()} searchData={[recordData]} />;
  };

  const isRecordShow = () => get(mappingData, 'franchise.echostarContentType') === 'SRM';

  const getRecordDetailsProps = () => ({
    detailExpandIcon: 'list showlisticon',
    whitelistKeys: ['franchiseEchostarId', 'roviProgramId', 'showName'],
  });

  return (
        <div className="bulk-mapping--message">
            <RecordDetails {...getRecordDetailsProps()} searchData={[mediaItemData]} />
            <div className="bulk-mapping--map-message">
                {fetched ? 'has been mapped to...' : 'will be mapped to...'}
            </div>
            {renderMappingResponseRecord()}
        </div>
  );
}

FranchiseHeader.propTypes = {
    fetched: PropTypes.bool,
    mappingData: PropTypes.object,
    mediaItemData: PropTypes.object,
};

function BulkMapping(props) {
  const {
    bulkMappingType,
    fetching,
    fetched,
    formData,
    mappingData,
    massActionData: { childFormName, label, showMessage, submitted, targets },
    massActionSetChildFormData,
    massActionSubmit,
    mediaItemData,
    setFieldValue,
    username,
  } = props;

  const getResponseTablewithsortProps = () => ({
    columnConfig: [
      {
        dataKey: 'target',
        title: 'Guid',
        link: '/media-items',
        linkKey: 'target',
        type: 'link',
        width: '35%',
      },
      {
        dataKey: 'statusPhrase',
        title: 'Status',
        width: '15%',
      },
      {
        dataKey: 'description',
        title: 'Title',
        width: '50%',
      },
    ],
  });

  const handleCompleteMapping = () => {
    massActionSetChildFormData({
      childFormName,
      label,
      showMessage: true,
    });
  };

  const renderBulkMappingButtons = () => (!fetching ? (
            <div className="bulk-mapping--bottom-buttons">
                <BulkMappingButtons
                    {...props}
                    handleCompleteMapping={() => handleCompleteMapping()}
                    shouldDisableCompleteButton={shouldDisableCompleteButton}
                />
            </div>
        ) : null);

  const submitForm = () => {
    massActionSubmit();
  };

  const handleResponseReset = () => {
    massActionSetChildFormData({
      childFormName,
      label,
      showMessage: false,
    });
  };

  const getResponseProps = () => {
    const { [childFormName]: childFormData = {} } = formData;
    const { columnConfig } = getResponseTablewithsortProps();

    return {
      columnConfig,
      formData: childFormData,
      label,
      onReset: () => handleResponseReset(props),
      username,
    };
  };

  const getActionCount = () => filter(map(targets, 'guid'), (guid) => !get(formData, 'bulkMapping.values.skippedGuids', []).includes(guid))
      .length;

  const shouldDisableCompleteButton = getActionCount() <= 0;

  const renderFormResponse = () => {
    let content = null;

    if (childFormName && showMessage) {
      if (submitted) {
        content = <MassActionResponse {...getResponseProps()} />;
      } else {
        content = (
                    <MassActionConfirm
                        actionsCount={getActionCount()}
                        label={label}
                        onReset={() => handleResponseReset()}
                        onSubmit={() => submitForm()}
                    />
        );
      }
    }

    return content ? <div className="bulk-mapping--response-overlay">{content}</div> : null;
  };

  return (
        <>
            {bulkMappingType === 'SHOWS' && <FranchiseHeader {...{ fetched, mappingData, mediaItemData }} />}
            <BulkMappingTable
                bulkMappingType={bulkMappingType}
                massActionTargets={targets}
                setFieldValue={setFieldValue}
            />
            {renderBulkMappingButtons()}
            {renderFormResponse()}
        </>
  );
}

BulkMapping.propTypes = {
    bulkMappingType: PropTypes.string.isRequired,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    formData: PropTypes.object,
    mappingData: PropTypes.object,
    massActionData: PropTypes.object,
    massActionSetChildFormData: PropTypes.func,
    massActionSubmit: PropTypes.func,
    mediaItemData: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
    username: PropTypes.string,
};

export default BulkMapping;
